import Layout from "@/components/Layout";
import ComingSoon from "@/components/ComingSoon";

const Status = () => {
  return (
    <Layout
      seoTitle="System Status - SKECHA"
      seoDescription="Check the current status of SKECHA services, uptime, and any ongoing maintenance or issues."
      seoKeywords="system status, uptime, service health, maintenance, status page"
      seoUrl="https://skecha.com/status"
    >
      <ComingSoon />
    </Layout>
  );
};

export default Status;